import React from "react";

import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";

import { Box, Typography } from "@mui/material";

import { COUNTRY_CODE } from "../helpers/constants";

const CustomPhoneNumberInput = ({
  values,
  touched,
  errors,
  setFieldValue,
  name,
  disabled = false,
  edit = true,
  otherProps,
  classes,
  placeholder = "Mobile Phone",
  isdefaultCountryUS = false,
  isFaxNumber = false,
  showError = true,
  errorOnlyWhenTouched = false,
}) => {
  const hasPhoneFormatError =
    Boolean(values?.[name]) && !isValidPhoneNumber(values?.[name]);
  const hasFieldError = touched?.[name] && errors?.[name]?.length > 0;
  const showValidationError = errorOnlyWhenTouched
    ? touched?.[name] && (hasFieldError || hasPhoneFormatError)
    : hasPhoneFormatError || hasFieldError;

  return (
    <>
      <Box
        className={`phone-number-input ${
          showValidationError &&
          edit &&
          !disabled &&
          !isFaxNumber
            ? "phone-error"
            : ""
        } ${classes}`}
      >
        <PhoneInput
          international={false}
          value={values?.[name]}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          countries={["US", "IN"]}
          limitMaxLength="10"
          defaultCountry={
            !isdefaultCountryUS && COUNTRY_CODE === "+91" ? "IN" : "US"
          }
          countryOptionsOrder={["US", "IN"]}
          addInternationalOption={false}
          onChange={(event) => {
            setFieldValue(name, event);
            if (!event) {
              setFieldValue(name, "");
            }
          }}
          className={`${disabled ? "show-disabled-text" : ""}`}
          {...otherProps}
        />
      </Box>
      {showError &&
        showValidationError &&
        edit &&
        !disabled &&
        !isFaxNumber && (
          <Typography
            sx={{
              color: "#d32f2f !important",
              fontSize: "12px !important",
              margin: "0px 0px 0px 0px !important",
              maxWidth: "100% !important",
              textAlign: "left",
            }}
          >
            Please enter a valid phone number
          </Typography>
        )}
    </>
  );
};

export default CustomPhoneNumberInput;
